<template lang="pug">
  #StoresManagerIndex
    h5.text-center.py-3.letter-spacing-6 店鋪管理
    b-row(
      no-gutters
      class="button-row"
    )
      b-col(
        cols=4,
        class="button-item-first"
      )
        b-button(
          block,
          :variant=" nowSelectType === 'index-sa' ? 'primary' : 'outline-primary' ",
          @click="changeTypeHandler('index-sa')",
          class="text-black border-gray"
        ) 店鋪CA
      b-col(
        cols=4
      )
        b-button(
          block,
          :variant=" nowSelectType === 'index-customer' ? 'primary' : 'outline-primary' ",
          @click="changeTypeHandler('index-customer')",
          class="text-black border-gray"
        ) 店鋪客戶
      b-col(
        cols=4
      )
        b-button(
          block,
          class="button-last rounded-0",
          :variant=" nowSelectType === 'index-reservation' ? 'primary' : 'outline-primary' ",
          @click="changeTypeHandler('index-reservation')",
          class="text-black border-gray"
        ) 店鋪預約

    div
      .customerInfo.mt-3(
        v-if="nowSelectType === 'index-customer' || nowSelectType === 'index-reservation'"
      )
        b-card.rounded-0(
          bg-variant="white",
          no-body,
          class="border-0"
        )
          b-card-body.py-2.px-3(
            class="searchArea"
          )
            .row.mb-2
              .col-10
                b-form-group.mb-3(
                  v-if="nowSelectType === 'index-customer'"
                )
                  b-input-group
                    b-select(
                      :option="customerClassOptions",
                      v-model="searchInput.customer_class"
                      @change='setTxMoneyStart()'
                    )
                      b-form-select-option(
                        v-for="(option,index) in customerClassOptions",
                        :key="option.id",
                        :value="option.id"
                      ) {{ option.name }}
                b-input-group.mb-3(
                  v-if="nowSelectType === 'index-reservation'"
                )
                  b-form-select(
                    v-model="searchInput.customer_tr",
                    placeholder="客戶TR"
                  )
                    template(
                      v-slot:first
                    )
                      b-form-select-option(
                        :value="null",
                        disabled
                      ) 客戶TR
                      b-form-select-option(
                        :value="'all'",
                      ) 全部
                    b-form-select-option(
                      v-for="(option,index) in tiffanyLevel",
                      :key="option.id",
                      :value="option.name"
                    ) {{ option.name }}
                b-collapse#collapse-searchBody
                  b-input-group.mb-3(
                    v-if="nowSelectType !== 'index-reservation'"
                  )
                    b-form-select(
                      v-model="searchInput.customer_tr",
                      placeholder="客戶TR"
                    )
                      template(
                        v-slot:first
                      )
                        b-form-select-option(
                          :value="null",
                          disabled
                        ) 客戶TR
                        b-form-select-option(
                          :value="'all'",
                        ) 全部
                      b-form-select-option(
                        v-for="(option,index) in tiffanyLevel",
                        :key="option.id",
                        :value="option.name"
                      ) {{ option.name }}
                  b-input-group.mb-3
                    b-form-select(
                      v-model="searchInput.customer_type",
                      placeholder="性別"
                    )
                      template(
                        v-slot:first
                      )
                        b-form-select-option(
                          :value="null",
                          disabled
                        ) 性別
                        b-form-select-option(
                          :value="'all'",
                        ) 全部
                      b-form-select-option(
                        v-for="(option,index) in tiffanyGender",
                        :key="option.id",
                        :value="option.id"
                      ) {{ option.name }}
                  b-input-group.mb-3
                    b-form-select(
                      v-model="searchInput.customer_birthday_month",
                      placeholder="客戶生日月份"
                    )
                      template(
                        v-slot:first
                      )
                        b-form-select-option(
                          :value="null",
                          disabled
                        ) 客戶生日月份
                      b-form-select-option(
                        v-for="month in 12",
                        :key="month",
                        :value="month"
                      ) {{ filterMonthToWord(month) }}
                  div.mb-3
                    b-input-group
                      b-form-input(
                        v-model="searchInput.tx_money_start"
                        placeholder="請輸入消費金額"
                      )
                      .mr-1.ml-1 ~
                      b-form-input(
                        v-model="searchInput.tx_money_end"
                        placeholder="請輸入消費金額"
                      )
                    small.redRemind(v-show="searchInput.customer_class === '10K' && ((searchInput.tx_money_start && parseInt(searchInput.tx_money_start, 10) < 300000) || (searchInput.tx_money_end && parseInt(searchInput.tx_money_end, 10) < 300000))") 消費金額不可少於300000
                  b-input-group.mb-3(
                    v-if="nowSelectType !== 'index-reservation'"
                  )
                    b-form-select(
                      v-model="searchInput.sa_id",
                      placeholder="CA"
                    )
                      template(
                        v-slot:first
                      )
                        b-form-select-option(
                          :value="null",
                          disabled
                        ) CA
                      b-form-select-option(
                        v-for="(option,index) in personnelList",
                        :key="option.id",
                        :value="option.id"
                      ) {{ option.preferred_name }}
              .col-2
                b-button(
                  variant="primary",
                  block,
                  v-b-toggle.collapse-searchBody
                )
                  i.fas.fa-align-justify.d-flex.align-items-center.justify-content-center.text-white
            .row.no-gutters
              .col-6.pr-1
                b-button(
                  variant="primary",
                  block,
                  @click="searchHandler()",
                  class="text-white"
                ) 搜尋
              .col-6.pl-1
                b-button(
                  variant="primary",
                  block,
                  @click="researtSearchHandler()",
                  class="text-white"
                ) 重置
      .reservationInfo.px-3(
        v-show="nowSelectType === 'index-reservation'"
      )
        b-row(
          no-gutters
          class="my-3 button-row"
        )
          b-col(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectStatus === 'reserving' ? 'primary selected' : 'light' ",
              @click="changeStatusHandler('reserving')",
              class="text-black rounded-0 border-gray"
            ) 申請預約
          b-col(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectStatus === 'checked' ? 'primary selected' : 'light' ",
              @click="changeStatusHandler('checked')",
              class="text-black rounded-0 border-gray"
            ) 完成預約
          b-col(
            cols=4
          )
            b-button(
              block,
              :variant=" nowSelectStatus === 'success' ? 'primary selected' : 'light' ",
              @click="changeStatusHandler('success')",
              class="text-black rounded-0 border-right border-gray"
            ) 到店諮詢
    .p-3
      i.fas.fa-users.fa-lg
      span.pl-2 {{ pagination.total }} 位
    b-card.border-0.mb-2.customerCard.overflow-hidden(
      bg-variant="light",
      v-for="(user,index) in storeData",
      :key="index",
      v-if="storeData && storeData.length > 0",
      body-class="p-0"
    )
      //- 店鋪SP
      .typeOneShow.p-3(
        v-if="nowSelectType === 'index-sa'"
      )
        .row.align-items-center.no-gutters.mb-3
          .col-3.pr-1
            ProfilePhotoSticker.d-flex.align-items-end.justify-content-center.border.border-black(
              :profileUrl="user.picture_url",
              :style="{ 'width': '60px', 'height': '60px' }"
            )
          .col-7.px-1
            .row.no-gutters
              .col-5.text-justify
                small.mb-0 姓名：
              .col-7
                small {{ user.preferred_name }}
              .col-5.text-justify
                small.mb-0 員工編號：
              .col-7
                small {{ user.sa_code }}
          .col-2.px-1
            b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button.iconBtn.position-absolute.iconEditBtn(
              variant="primary",
              @click="editSaStatus(user, index, true)"
              style="width: 40px; height: 40px;"
            )
              i.fas.fa-pencil-alt.iconEdit
        .baInfoRow
          b-row
            b-col(
              cols=6
              class="d-flex align-items-center"
            )
              i.fas.fa-user.mr-2
              small 客戶數：{{ user.member_count }}位
      .baSettingRow(v-show="nowSelectType ==='index-sa' && user.settingMode")
        .text-center 任職狀態維護
        .selectStatusArea.position-relative.p-3.m-3
          label.custom-radio 離職
            input(type='radio', name='in_service_status', v-model='in_service_status', value='resign')
            span.checkmark(:style="{  'background-color' : in_service_status === 'resign' ? '#000' : '' }")
          .selectBaArea(v-show="in_service_status === 'resign'")
            .text-center.mt-1.pt-3 請選擇欲承接客戶之CA
            .row.m-2
              .baList.m-3(v-for='(personnel, index) in filterPersonnelList')
                b-form-checkbox(
                  :id="`personnel-${index}`",
                  v-model="selectPersonnels",
                  :name="`personnel-${index}`",
                  :value="personnel.id",
                ) {{ personnel.preferred_name }}
          label.custom-radio.m-0 留職停薪
            input(type='radio', name='in_service_status', v-model='in_service_status', value='leave_without_pay')
            span.checkmark(:style="{  'background-color' : in_service_status === 'leave_without_pay' ? '#000' : '' }")
          .selectBaArea(v-show="in_service_status === 'leave_without_pay'")
            .text-center.mt-1.pt-3 請選擇欲承接客戶之CA
            .row.m-2
              .baList.m-3(v-for='(personnel, index) in filterPersonnelList')
                b-form-checkbox(
                  :id="`personnel-${index}`",
                  v-model="selectPersonnels",
                  :name="`personnel-${index}`",
                  :value="personnel.id",
                ) {{ personnel.preferred_name }}

        .text-center
          .buttonArea.mt-3.pb-5
            .mx-5.no-gutters
              b-button.col-4.mx-2(
                variant="primary",
                @click="editSaStatus(user, index, false)"
                class="rounded-25 text-black border-gray"
              ) 取消
              b-button.col-4.mx-2(
                variant="primary",
                @click="sendPersonnelSettingHandler(user)"
                class="rounded-25 text-black border-gray"
              ) 儲存設定

      //- 店鋪顧客
      .typeTwoShow(
        v-if="nowSelectType === 'index-customer' || nowSelectType === 'index-reservation'"
      )
        .p-3
          .row.align-items-center.no-gutters.mb-3
            .col-3.pr-1
              ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                :profileUrl="user.picture_url",
                :style="{ 'width': '70px', 'height': '70px' }"
              )
            .col-9.pl-1
              p.mb-0.font-weight-bold.text-17 {{ first_name(user) }}
              .row.no-gutters
                .col-6
                  small 暱稱名：{{ user.line_name }}
                .col-6
                  small 備註名：{{ user.customer_note_name }}
                .col-12
                  small ECM ID：{{ user.ecm_id }}
                .col-6
                  small.mb-0 客戶TR：
                  b-badge(
                    variant="primary",
                    class="rounded-0 p-1 bg-primary"
                  ) {{ TRList.includes(user.level) ? user.level : '' }}
                .col-6
                  small.mb-0 性別：
                  b-badge(
                    variant="primary",
                    class="rounded-0 p-1 bg-primary"
                  ) {{ genderList.includes(user.gender) ? user.gender : '' }}
                .col-6(v-show="nowSelectType === 'index-reservation'")
                  small 一對一CA：{{ user.sa_name }}
        .py-2.px-3.bg-primary
          .row.align-items-center.no-gutters
            .col-6
              .d-flex.align-items-center
                i.fas.fa-birthday-cake.mr-2
                small 生日：{{ filterMonthToWord(user.birthday) }}
            .col-6
              small 上次到店資訊日期：{{ user.last_reserve_start_at }}
            .col-6
              .d-flex.align-items-center
                i.fas.fa-mobile-alt.mr-2
                small 電話：{{ user.mobile?user.mobile:user.reserve_mobile }}
            .col-6
              small 上次服務CA：{{ user.last_preferred_name }}
            .col-6
              small 今年消費金額：{{ user.tx_money!=0 ? user.tx_money : '-' }}
            .col-6
              small 上次交易CA：{{ user.tx_sp_name }}
        .p-3
          .row.align-items-center.no-gutters(
            v-if="nowSelectType === 'index-customer'"
          )
            .col-6.mb-2
              .d-flex.align-items-center
                i.far.fa-calendar-check.mr-2
                small 負責CA：{{ user.sa_preferred_name }}
            .col-12.mb-2
              .labelRow.d-flex.align-items-center.flex-wrap.mb-3
                i.fas.fa-tag.mr-2
                small 客戶標籤：
                b-badge.m-1.rounded-0.p-1(
                  variant="primary",
                  v-for="(label,index) in user.tags"
                  :key="label.tag_id"
                ) {{ label.tag_name }}
          .row.align-items-center.no-gutters(
            v-if="nowSelectType === 'index-reservation'"
          )
            .col-6.mb-2
              .d-flex.align-items-center
                i.far.fa-calendar-check.mr-2
                small 預約日期：{{ user.reserve_date }}
            .col-6.mb-2
              .d-flex.align-items-center
                i.far.fa-clock.mr-2
                small 預約時間：{{ moment(user.reserve_start_at).format('HH:mm') }}~{{ moment(user.reserve_end_at).format('HH:mm') }}
            .col-12.mb-2
              .d-flex.align-items-center
                i.far.fa-clipboard.mr-2
                small(v-if="user.reserve_type_name !== null") 服務內容：{{ user.reserve_type_name }}
                small(v-else-if="user.activity_name !== null") 參加event：{{ user.activity_name }} ({{ user.experience === 0 ? '到店體驗' : '線上體驗' }})
                small(v-else) 服務內容：
            .col-12.mb-2
              .d-flex.align-items-center
                i.fas.fa-mobile-alt.mr-2
                small 預約手機：{{ user.reserve_mobile ? user.reserve_mobile : '' }}
            .col-12.mb-2(
              v-if="user.status === 'reserving'",
              :class="{ 'col-6': editMode.indexOf(user) === -1, 'col-12': editMode.indexOf(user) !== -1 }"
            )
              .d-flex.align-items-center
                i.far.fa-clipboard.mr-2
                small.word-break-keep-all 指派CA：
                  small(
                    v-if="editMode.indexOf(user) === -1"
                  ) {{ user.sa_preferred_name ? user.sa_preferred_name : '尚未指派' }}
                b-form-select(
                  id="sp",
                  required,
                  v-model="assignSP",
                  v-if="editMode.indexOf(user) !== -1",
                  placeholder="請選擇指派CA",
                  @change="selectAssignSPHandler(user.reservation_id)"
                )
                  template(
                    v-slot:first
                  )
                    b-form-select-option(
                      :value="null",
                      disabled
                    ) 請選擇指派CA
                  b-form-select-option(
                    v-for="sp in assignSp",
                    :key="sp.personnel_id",
                    :value="sp.personnel_id"
                  ) {{ sp.personnel_name }}
                b-button.rounded-50.d-flex.align-items-center.justify-content-center.mx-1.button.iconBtn.iconEditBtn(
                  variant="primary",
                  @click="assignSPHandler(user)",
                  width="10",
                  height="10",
                  v-if="editMode.indexOf(user) === -1 && !user.sa_preferred_name"
                )
                  i.fas.fa-pencil-alt.iconEdit.fa-sm
                b-button.rounded-50.d-flex.align-items-center.justify-content-center.mx-1.button.iconBtn.iconCrossBtn(
                  variant="primary",
                  @click="closeAssignSPHandler(user)",
                  width="15",
                  height="15",
                  v-if="editMode.indexOf(user) !== -1 && !user.sa_preferred_name"
                )
                  i.far.fa-times-circle.fa-sm
            .col-6.mb-2(v-else)
              .d-flex.align-items-center
                i.far.fa-clipboard.mr-2
                small 服務CA(指派CA)：{{ user.sa_preferred_name }}

            .col-12.mb-2
              .d-flex.align-items-center
                i.fas.fa-users.mr-2
                small 參與人數：{{ user.companion_number }}
            .col-12.mb-2
            .d-flex
              i.fas.fa-clipboard.mr-2.flex-wrap.mb-3
              small 客戶備註： {{ user.m_note }}
            .col-12.mb-2
              .labelRow.d-flex.align-items-center.flex-wrap.mb-3
                i.fas.fa-tag.mr-2
                small 客戶標籤：
                b-badge.m-1.rounded-0.p-1(
                  variant="primary",
                  v-for="(label,index) in user.tags"
                  :key="label.tag_id"
                ) {{ label.tag_name }}
    infinite-loading(
      @infinite="infiniteHandler",
      :identifier="infiniteId",
      spinner="bubbles"
    )
      .cursor-default(slot="no-more") 無更多資料
      .cursor-default(slot="no-results") 無更多資料
      .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import InfiniteLoading from 'vue-infinite-loading';

const moment = require('moment');
const _ = require('lodash');

export default {
  name: 'StoresManagerIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      nowSelectType: 'index-sa',
      nowSelectStatus: 'reserving',
      infiniteId: +new Date(),
      customerClassOptions: [
        {
          id: 'binding',
          name: '摯友品牌客戶' // 摯友(品牌顧客) + 封鎖-摯友（品牌顧客）
        },
        {
          id: 'not_binding',
          name: '摯友非品牌客戶' // 摯友(非品牌顧客) + 封鎖-摯友（非品牌顧客）
        },
        {
          id: '10K',
          name: '10K客戶' // 每月上傳名單 今年交易金額 > 10萬
        },
        {
          id: 'others',
          name: '預約服務客戶'
        }
      ],
      searchInput: {
        customer_class: 'binding',
        customer_tr: null,
        customer_type: null,
        customer_birthday_month: null,
        sa_id: null,
        tx_money_start: '',
        tx_money_end: ''
      },
      editMode: [],
      assignSP: null,
      in_service_status: '',
      nowSettingPersonnelIndex: -1,
      nowSettingPersonnelId: -1,
      selectPersonnels: []
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sm_stores_manager/resetHandler');
    vm.$store.dispatch('sm_stores_manager/getTiffanyMemberLevelAndGenderHandler')
      .then(() => {
        vm.$swal.close();
      });
    vm.$store.dispatch('sm_stores_manager/getStorePersonnellListHandler', vm.smData.stores[0].id);
  },
  methods: {
    first_name(user) {
      if (user.created_by === 'USER') {
        return user.reserve_last_name + user.reserve_first_name;
      }
      if (user.customer_chinese_last_name && user.customer_chinese_first_name) {
        return user.customer_chinese_last_name + user.customer_chinese_first_name;
      }
      return user.line_name;
    },
    moment(data = null) {
      return data ? moment(data) : moment();
    },
    infiniteHandler($state) {
      const vm = this;
      let targetApi;
      if (!vm.smData) {
        $state.complete();
        return;
      }
      switch (vm.nowSelectType) {
        case 'index-sa':
          targetApi = 'getIndexSaHandler';
          break;
        case 'index-customer':
          targetApi = 'getIndexCustomerHandler';
          break;
        case 'index-reservation':
          targetApi = 'getIndexReservationHandler';
          break;
        default:
          break;
      }
      if (!vm.smData || !targetApi) return;
      vm.$store.dispatch(`sm_stores_manager/${targetApi}`, {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        store_id: vm.smData.stores[0].id,
        status: vm.nowSelectStatus,
        customer_class: vm.nowSelectType === 'index-customer' ? vm.searchInput.customer_class : null,
        customer_tr: vm.nowSelectType === 'index-customer' || vm.nowSelectType === 'index-reservation' ? vm.searchInput.customer_tr : null,
        customer_type: vm.nowSelectType === 'index-customer' || vm.nowSelectType === 'index-reservation' ? vm.searchInput.customer_type : null,
        customer_birthday_month: vm.nowSelectType === 'index-customer' || vm.nowSelectType === 'index-reservation' ? vm.searchInput.customer_birthday_month : null,
        sa_id: vm.nowSelectType === 'index-customer' ? vm.searchInput.sa_id : null,
        tx_money_start: vm.searchInput.tx_money_start.trim() !== '' ? vm.searchInput.tx_money_start : null,
        tx_money_end: vm.searchInput.tx_money_end.trim() !== '' ? vm.searchInput.tx_money_end : null
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    changeTypeHandler(type) {
      const vm = this;
      switch (type) {
        case 'index-sa':
          if (vm.nowSelectType === 'index-sa') return;
          vm.nowSelectType = 'index-sa';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.researtSearchHandler();
          break;
        case 'index-customer':
          if (vm.nowSelectType === 'index-customer') return;
          vm.nowSelectType = 'index-customer';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.researtSearchHandler();
          break;
        case 'index-reservation':
          if (vm.nowSelectType === 'index-reservation') return;
          vm.nowSelectType = 'index-reservation';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.researtSearchHandler();
          break;
        default:
          break;
      }
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'reserving':
          if (vm.nowSelectStatus === 'reserving') return;
          vm.nowSelectStatus = 'reserving';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'checked':
          if (vm.nowSelectStatus === 'checked') return;
          vm.nowSelectStatus = 'checked';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'success':
          if (vm.nowSelectStatus === 'success') return;
          vm.nowSelectStatus = 'success';
          vm.$store.commit('sm_stores_manager/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    searchHandler() {
      const vm = this;
      vm.$store.commit('sm_stores_manager/resetHandler');
      vm.checkSearch().then(() => {
        vm.infiniteId += 1;
      });
    },
    researtSearchHandler() {
      const vm = this;
      vm.searchInput.customer_class = 'binding';
      vm.searchInput.customer_tr = null;
      vm.searchInput.customer_type = null;
      vm.searchInput.customer_birthday_month = null;
      vm.searchInput.sa_id = null;
      vm.$store.commit('sm_stores_manager/resetHandler');
      vm.infiniteId += 1;
    },
    assignSPHandler(user) {
      const vm = this;
      vm.assignSP = null;
      vm.editMode = [];
      if (vm.editMode.indexOf(user) === -1) {
        vm.editMode.push(user);
        vm.$swal.fire({
          title: '請稍候，\n取得可指派CA中',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        vm.$store.dispatch('sm_stores_manager/getAssignSpDropdownHandler', {
          store_id: vm.smData.stores[0].id,
          reserve_date: user.reserve_date,
          reservation_period_id: user.reservation_period_id
        })
          .then(() => {
            vm.$swal.close();
          });
      }
    },
    closeAssignSPHandler(user) {
      const vm = this;
      vm.assignSP = null;
      vm.editMode = [];
      if (vm.editMode.indexOf(user) !== -1) {
        vm.editMode.splice(vm.editMode.indexOf(user), 1);
      }
    },
    selectAssignSPHandler(reservation_id) {
      const vm = this;
      if (!vm.assignSP) return;
      const assignSPKey = _.findKey(vm.assignSp, (val) => val.personnel_id === vm.assignSP);

      vm.$swal.fire({
        title: '您確定指派預約？',
        html: `將指派此預約給CA <span style="color: #d33">${vm.assignSp[assignSPKey].personnel_name}</span>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary px-5'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '請稍候，\n指派CA中',
            allowOutsideClick: false,
            willOpen: () => {
              this.$swal.showLoading();
            }
          });

          vm.$store.dispatch('sm_stores_manager/assignReservationHandler', {
            reservation_id,
            personnel_id: vm.assignSP
          })
            .then(() => {
              vm.$snotify.success(null, '指派成功');
              vm.$swal.close();
              vm.assignSP = null;
              vm.editMode = [];
              vm.searchHandler();
            });
        } else {
          vm.assignSP = null;
        }
      });
    },
    editSaStatus(personnel, index, status) {
      const vm = this;
      // 重複選取 改為關閉
      if (index === vm.nowSettingPersonnelIndex && vm.storeData[index].settingMode === true) {
        status = false;
      }

      if (vm.nowSettingPersonnelIndex !== -1) {
        vm.$store.commit('sm_stores_manager/setStoreDataSetting', {
          index: vm.nowSettingPersonnelIndex,
          status: false
        });
      }
      vm.nowSettingPersonnelIndex = index;
      vm.nowSettingPersonnelId = personnel.sa_id;
      vm.selectPersonnels = [];
      if (status) {
        vm.$store.dispatch('sm_stores_manager/getStorePersonnellListHandler', vm.storeInfo.id);
      }
      vm.$store.commit('sm_stores_manager/setStoreDataSetting', { index, status });
    },
    sendPersonnelSettingHandler(personnel) {
      const vm = this;
      const text = vm.in_service_status === 'resign' ? '離職' : '留職停薪';
      vm.$swal.fire({
        title: `請確認是否欲設定${personnel.preferred_name}此CA狀態為${text}`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '請稍候，更新CA狀態中',
            allowOutsideClick: false,
            onOpen: function onOpen() {
              vm.$swal.showLoading();
            }
          });

          const input = {
            sa_id: vm.nowSettingPersonnelId,
            transform_id: vm.selectPersonnels,
            type: vm.in_service_status
          };

          vm.$store.dispatch('sm_stores_manager/settingPersonnelStatusHandler', input).then(() => {
            vm.$swal.close();
            vm.$store.commit('sm_stores_manager/setStoreDataSetting', {
              index: vm.nowSettingPersonnelIndex,
              status: false
            });
            vm.researtSearchHandler();
            vm.$snotify.success(null, '設定成功');
          });
        }
      });
    },
    setTxMoneyStart() {
      const vm = this;
      if (vm.searchInput.customer_class !== '10K') {
        vm.searchInput.tx_money_start = '';
        vm.searchInput.tx_money_end = '';
        return;
      }
      if (!vm.searchInput.tx_money_start || parseInt(vm.searchInput.tx_money_start, 10) < 300000) vm.searchInput.tx_money_start = '300000';
      if (vm.searchInput.tx_money_end && parseInt(vm.searchInput.tx_money_end, 10) < 300000) vm.searchInput.tx_money_end = '';
    },
    checkSearch() {
      const vm = this;
      return new Promise((resolve) => {
        if (vm.nowSelectType === 'index-reservation') resolve();
        if (vm.searchInput.customer_class === '10K') {
          if ((!vm.searchInput.tx_money_start || parseInt(vm.searchInput.tx_money_start, 10) < 300000) || (vm.searchInput.tx_money_start && parseInt(vm.searchInput.tx_money_end, 10) < 300000)) {
            vm.$swal.fire({
              title: '消費金額無法低於300000',
              icon: 'info'
            });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
  },
  computed: {
    ...mapState({
      smData: (state) => state.sm.smData,
      storeData: (state) => state.sm_stores_manager.storeData,
      storeDealer: (state) => state.sm_stores_manager.storeDealer,
      stores: (state) => state.sm_stores_manager.stores,
      storeInfo: (state) => state.sm_stores_manager.storeInfo,
      pagination: (state) => state.sm_stores_manager.pagination,
      tiffanyLevel: (state) => state.sm_stores_manager.tiffanyLevel,
      tiffanyGender: (state) => state.sm_stores_manager.tiffanyGender,
      assignSp: (state) => state.sm_stores_manager.assignSp,
      personnelList: (state) => state.sm_stores_manager.personnelList,
      TRList: (state) => state.sa.TRList,
      genderList: (state) => state.sa.genderList,
    }),
    filterPersonnelList() {
      const vm = this;
      return _.filter(vm.personnelList, (val) => val.id !== vm.nowSettingPersonnelId);
    }
  }
};
</script>

<style lang="scss" scoped>
.multiselect__placeholder {
  margin-bottom: 8px;
}

.selectStatusArea {
  background-color: #67C2BB;
}
.baSettingRow {
  border: 2px solid #000;
}
.custom-radio {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.custom-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 3px;
  left: 3px;
  height: 1.2rem;
  width: 1.2rem;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.custom-radio:hover input ~ .checkmark {
  background-color: #eee;
}

/* When the radio button is checked, add a blue background */
.custom-radio input:checked ~ .checkmark {
  background-color: #000;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.custom-radio input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.custom-radio .checkmark:after {
  border-radius: 50%;
  background: white;
}

.selectBaArea {
  background-color: #FFF;
}
</style>
